export default __webpack_public_path__ + "static/media/char-han-solo.b1c58b67.jpg";